import React from 'react';
import { Form } from 'react-bootstrap';
import { SingleValue } from 'react-select';
import Sorting from '../../enums/sorting-enum';
import SelectComponent, { SelectOption } from '../select/select-component';

interface SortComponentProperties {
  onSort: (sortingValue: Sorting) => void;
  ascendingCaption: string;
  descendingCaption: string;
  selectedValue: string;
}

export default function SortComponent(props: SortComponentProperties): JSX.Element {
  const { onSort, ascendingCaption, descendingCaption, selectedValue } = props;

  const sortChange = (value: SingleValue<SelectOption>): void => {
    if (value) {
      onSort(value.value as Sorting);
    }
  };

  const options: SelectOption[] = [
    {
      label: Sorting.None,
      value: Sorting.None,
    },
    {
      label: ascendingCaption,
      value: Sorting.Ascending,
    },
    {
      label: descendingCaption,
      value: Sorting.Descending,
    },
  ];

  const optionSelected = options.find((option) => option.value === selectedValue)!;
  return (
    <div className="d-flex flex-row align-items-center">
      <Form.Label className="m-0 nowrap me-3">Sort by</Form.Label>

      <div className="flex-grow-1">
        <SelectComponent options={options} onChange={sortChange} value={optionSelected} />
      </div>
    </div>
  );
}
